import ContentSwitch from './ContentSwitch';

export default ContentSwitch;
